import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './SidebarFooter.module.scss';
import { useTour } from 'app-context/tourContext/TourContext';
import ContactSupport from 'component/layout/sidebar/components/contact-support/ContactSupport';
import { useUserContext } from 'app-context/user/UserContext';

const downArrow = '/src/svg/arrows/chevron-down.svg';

const SidebarFooter = ({ data, isUserChat = false }) => {
  const { userData } = useUserContext();
  const navigate = useNavigate();

  const footerRef = useRef(null);

  const [isOpen, setIsOpenDropdown] = useState(false);
  const [showContactSupportModal, setShowContactSupportModal] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('selectedBot');
    window.location.reload();

    navigate('/');
  };

  const handleNavigateProfile = () => {
    if (isUserChat) {
      navigate('/user/profile');
    } else navigate('/profile');
  };

  const handleQuickTour = () => {
    // const tourConfig = getTourConfig(
    //   location.pathname,
    //   data?.data?.items ? data.data.items[0].botId : undefined
    // );
    // startTour(tourConfig);
  };

  const handleContactSupport = () => {
    setShowContactSupportModal(true);
  };

  const ProfileData = [
    {
      id: 1,
      label: 'View Profile',
      icon: '/src/svg/profile/users.svg',
      action: handleNavigateProfile,
    },
    // {
    //   id: 2,
    //   label: 'Quick Tour',
    //   icon: '/src/svg/profile/quick.svg',
    //   action: handleQuickTour,
    // },
    // {
    //   id: 3,
    //   label: 'Contact Support',
    //   icon: '/src/svg/profile/support.svg',
    //   action: handleContactSupport,
    // },
    {
      id: 4,
      label: 'Logout',
      icon: '/src/svg/profile/logout.svg',
      danger: true,
      action: handleLogout,
      color: 'red',
    },
  ].filter((item) => !(isUserChat && item.id === 2));
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (footerRef.current && !footerRef.current.contains(e.target)) {
        setIsOpenDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const firstName = userData?.authUser?.firstName ?? '';
  const lastName = userData?.authUser?.lastName ?? '';
  const shouldBreakLine = `${firstName} ${lastName}`.trim().length > 17;
  return (
    <>
      <div
        style={{ width: '100%', height: '1px', background: '#e0e0e0' }}
      ></div>
      <div
        className={styles['bar-footer']}
        ref={footerRef}
        onClick={() => setIsOpenDropdown((prev) => !prev)}
        style={{ marginBottom: isUserChat ? '0px' : '' }}
      >
        {' '}
        <div className={styles['bar-profile']}>
          {userData?.userImage?.userImage ? (
            <div className={styles['image']}>
              <img
                src={`data:image/jpeg;base64,${userData.userImage.userImage}`}
                alt='Expand'
                className={styles['expand-btn']}
              />
            </div>
          ) : (
            <div className={styles['image-placeholder']}>
              <p>
                {userData?.authUser?.firstName?.charAt(0)}
                {userData?.authUser?.lastName?.charAt(0)}
              </p>
            </div>
          )}

          <p>
            <span>
              {firstName.length > 17
                ? `${firstName.slice(0, 17)}...`
                : firstName}
            </span>

            {shouldBreakLine ? <br /> : ' '}

            <span>
              {lastName.length > 17 ? `${lastName.slice(0, 17)}...` : lastName}
            </span>
          </p>
        </div>
        <img
          src={downArrow}
          alt='Expand'
          className={`${isOpen ? styles['up'] : ''}`}
          onClick={() => setIsOpenDropdown((prev) => !prev)}
        />
        {isOpen && (
          <div className={styles['profile-list']} role='menu'>
            {ProfileData.map((item) => (
              <div
                key={item.id}
                className={`${styles['profile-item']} ${
                  item.danger ? styles['danger'] : ''
                }`}
                onClick={item.action}
                role='menuitem'
              >
                <img src={item.icon} alt='' className={styles['item-icon']} />
                <span className={styles['title']} style={{ color: item.color }}>
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
      <ContactSupport
        isOpen={showContactSupportModal}
        onClose={() => setShowContactSupportModal(false)}
        data={data}
      />
    </>
  );
};

export default SidebarFooter;
